// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_ju-2";
export var aiChatCartContainerExit = "_ju-4";
export var aiChatContainerLarge = "_ju-0";
export var aiChatContainerSmall = "_ju-1";
export var aiChatIcon = "_ju-6";
export var slideInFromRight = "_ju-3";
export var slideOutToRight = "_ju-5";